export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
export const COVER_URL = process.env.REACT_APP_COVER_URL
export const RECOMMEND_SERVICE_URL = process.env.REACT_APP_RECOMMEND_SERVICE_URL